import React from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { HeaderMarginContainer } from 'Deer/components/HeaderComponents/HeaderMarginContainer';
import { addYears, startOfDay } from 'date-fns';

import { past12Months } from 'constants/ProjectConstants';
import { getDateRangeFromLSBasedOnEndDateStartDate } from 'constants/helper';
import { isMobileView } from 'constants/isMobileView';
import { localStorageKeys } from 'constants/localStorageKeys';

import { DateRangeDropdown } from 'uiToolkitV1/DateRange';
import { Select } from 'uiToolkitV1/Select';
import { TextHeader2 } from 'uiToolkitV1/Typography';

export const StyledSelect = styled(Select)`
  width: unset;
  .select__menu {
    right: 0;
  }
`;

const RenderTitle = ({ cohortName }) => {
  const updatedTitles = cohortName === 'My initiatives' ? `${cohortName} for` : `${cohortName}'s initiatives for`;
  return (
    <TextHeader2 mr="8px" bold lineHeight="16px" fontSize={isMobileView() ? '0.875rem' : '1.25rem'}>
      {cohortName && updatedTitles}
    </TextHeader2>
  );
};

function TabbedNavigationTitle({ cohortName, updateDateRange }) {
  const onDateRangeChange = (date) => {
    if (updateDateRange) {
      // // handling case when date range is cleared
      // // date is returned as undefined
      // // but in non-rabbit it's treated as endOfToday - 1 year
      // // doing the same
      // if (!date?.endDate && !date?.startDate) {
      //   const allDateRange = {
      //     endDate: endOfDay()?.valueOf(),
      //     startDate: subMonths(startOfMonth(new Date()), 12)?.valueOf()
      //   };
      //   updateDateRange(allDateRange);
      // } else {
      updateDateRange(date);
      // }
    }
  };

  const renderTimelineDropdown = () => (
    <DateRangeDropdown
      onSelect={onDateRangeChange}
      minDate={new Date(2020, 5, 1, 0, 0, 0, 0)}
      maxDate={addYears(startOfDay(new Date()), 5)}
      getTimestamp
      initialDateRange={
        getDateRangeFromLSBasedOnEndDateStartDate(localStorageKeys?.rabbitInitiativeAnalyticsFilters) ?? past12Months
      }
      showPredefinedRanges
      enableEmptyDateRangeToBeSelected
    />
  );

  return (
    <HeaderMarginContainer>
      <Flex h="48px" alignItems="center" mb={1} direction={isMobileView() ? 'column' : 'row'}>
        <RenderTitle cohortName={cohortName} />
        <Flex>{renderTimelineDropdown()}</Flex>
      </Flex>
    </HeaderMarginContainer>
  );
}

export default TabbedNavigationTitle;
